import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Card, CardBody } from 'reactstrap'

import InvoicesTable from './partials/InvoicesTable'
import CustomFiltersDrawer from './partials/CustomFiltersDrawer'
import ListTopBar from '../../components/ListTopBar'

import { getInvoices } from './services'
import { handleError, parsePagination } from '../../helpers'
import moment from 'moment'

export default function InvoicesList() {
	const user = useSelector(state => state.auth.user)
	const [invoices, setInvoices] = useState(null)
	const [filterType, setFilterType] = useState('reference')
	const [filterValue, setFilterValue] = useState('')
	const [filterScope, setFilterScope] = useState('')
	const [pagination, setPagination] = useState({page: 1, per_page: 15, total: 0})
	const [filters, setFilters] = useState({
		'filter[products.category]': '',
		'filter[sold_at_from]': '2015-01-01',
		'filter[sold_at_until]': moment().subtract(1, 'days').format('YYYY-MM-DD'),
		'filter[products.family]': [],
	})
	const [showFiltersDrawer, setShowFiltersDrawer] = useState(false)

	useEffect(() => {
		!invoices && getInvoices({
			[`filter[${filterType}]`]: filterValue,
			[filterScope ? `filter[${filterScope}]` : 'noscope']: 1,
			'filter[last_store_code]': user.current_store_code,
			sort: '-sold_at',
			include: 'products,customer.callLogs,customer.saleLogs,customer.invoices.products,clickLogsCount',
			...pagination,
			...filters
		})
			.then(res => {
				setInvoices(res.data.data)
				setPagination(parsePagination(res))
			})
			.catch(error => handleError(error))
	}, [ invoices, filterType, filterValue, pagination, user, filters, filterScope ])

	return (
		<React.Fragment>
			<ListTopBar 
				filterType={filterType}
				setFilterType={setFilterType}
				filterValue={filterValue}
				setFilterValue={setFilterValue}
				title={`Facturas Tienda ${user.current_store_code}`}
				subtitle="Momentos Spring"
				reload={() => setInvoices(null)}
				options={[
					{ label: 'Buscar referencia factura', value: 'reference' },
					{ label: 'Buscar nombre de producto', value: 'products.description' },
					{ label: 'Buscar nombre del cliente', value: 'customer.name' },
					{ label: 'Buscar cédula del cliente', value: 'customer.document' },
				]}
				ctaText="Filtros Avanzados"
				handleCtaClick={() => setShowFiltersDrawer(true)}
				filterScope={filterScope}
				setFilterScope={setFilterScope}
				scopeLabel="Estado"
				scopes={[
					{ label: 'Facturas Sin Seguimiento', value: 'without_followup' },
					{ label: 'Facturas Con Seguimiento', value: 'with_followup' },
				]}
			/>
			<Card>
				<CardBody>
					<InvoicesTable
						invoices={invoices}
						reload={() => setInvoices(null)}
						pagination={pagination}
						setPagination={setPagination}
					/>
				</CardBody>
			</Card>
			{ showFiltersDrawer && (
				<CustomFiltersDrawer 
					visible
					onClose={() => setShowFiltersDrawer(false)}
					reload={() => setInvoices(null)}
					filters={filters}
					setFilters={setFilters}
				/>
			)}
		</React.Fragment>
	)
}